var _g, _path, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8440_135794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30225 26.7593L8.30225 26.2339C8.30225 25.999 8.11039 25.8086 7.87372 25.8086L4.80255 25.8086C4.56588 25.8086 4.37403 25.999 4.37403 26.2339L4.37403 26.7593C4.37403 26.9942 4.56588 27.1846 4.80255 27.1846L7.87372 27.1846C8.11039 27.1846 8.30225 26.9942 8.30225 26.7593Z",
    fill: "#60585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80127 41.3726L8.80127 40.8472C8.80127 40.6123 8.60941 40.4219 8.37274 40.4219L5.30158 40.4219C5.06491 40.4219 4.87305 40.6123 4.87305 40.8472L4.87305 41.3726C4.87305 41.6075 5.06491 41.7979 5.30158 41.7979L8.37274 41.7979C8.60941 41.7979 8.80127 41.6075 8.80127 41.3726Z",
    fill: "#60585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0611 35.2082C36.0451 35.4793 36.0417 35.7599 36.0781 36.0289C36.1136 36.206 36.2661 36.5973 36.5112 36.4082C36.7629 36.1483 36.7243 35.6883 36.696 35.3598L36.9952 35.3344C37.0326 35.7866 37.0447 36.3334 36.6793 36.6641C36.204 36.9604 35.8607 36.4969 35.7799 36.0684C35.7434 35.782 35.7625 35.4955 35.7456 35.2083L36.0611 35.2083L36.0611 35.2082Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6394 35.2082C37.6554 35.4793 37.6587 35.7599 37.6224 36.0289C37.5868 36.206 37.4344 36.5973 37.1893 36.4082C36.9376 36.1483 36.9762 35.6883 37.0044 35.3598L36.7052 35.3344C36.6678 35.7866 36.6557 36.3334 37.0211 36.6641C37.4964 36.9604 37.8397 36.4969 37.9205 36.0684C37.9571 35.7819 37.9379 35.4955 37.9548 35.2083L37.6394 35.2083L37.6394 35.2082Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9541 34.1492C36.9443 34.2515 36.9486 34.3566 36.948 34.4591C36.9477 34.5459 36.903 34.8372 36.9978 34.8913C37.0654 34.9103 37.1427 34.8779 37.1805 34.8215C37.2513 34.6849 37.2152 34.5004 37.2081 34.3538C37.1995 34.1745 37.1795 33.9312 37.3994 33.8764C37.579 33.8594 37.7512 33.9705 37.8554 34.109C37.9689 34.2922 37.9479 34.5008 37.922 34.7052C37.9057 34.8269 37.8869 34.9483 37.8731 35.0703L37.6833 35.0479C37.698 34.9255 37.7184 34.8038 37.7347 34.6816C37.7532 34.5322 37.7812 34.3606 37.701 34.2238C37.6449 34.145 37.5416 34.0691 37.4403 34.0685C37.3649 34.0678 37.3946 34.3015 37.3968 34.3441C37.4074 34.5419 37.4396 34.7569 37.3365 34.9364C37.2273 35.081 37.0186 35.1448 36.8631 35.0327C36.7229 34.8862 36.7591 34.6452 36.7585 34.4591C36.758 34.3566 36.7623 34.2515 36.7524 34.1492L36.9541 34.1492Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7578 33.9922C36.7699 33.8735 36.7651 33.7507 36.7658 33.6316C36.7666 33.407 36.7649 33.1824 36.764 32.9578C36.7637 32.9128 36.7634 32.8677 36.7621 32.8227L36.9332 32.8227C36.9318 32.8677 36.9315 32.9128 36.9312 32.9578C36.9303 33.1824 36.9286 33.407 36.9294 33.6316C36.9301 33.7507 36.9253 33.8735 36.9374 33.9922L36.7578 33.9922Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8833 33.3294C36.9492 33.3386 37.0186 33.3339 37.0847 33.3344C37.2167 33.335 37.3486 33.3351 37.4806 33.3341C37.568 33.3334 37.6554 33.3324 37.7428 33.3322C37.7951 33.3322 37.8474 33.3323 37.8997 33.3324L37.8997 33.5243C37.8474 33.5244 37.7951 33.5246 37.7428 33.5245C37.6554 33.5243 37.568 33.5234 37.4806 33.5227C37.3486 33.5216 37.2167 33.5216 37.0847 33.5223C37.0186 33.5228 36.9492 33.5181 36.8833 33.5273L36.8833 33.3294Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7935 32.5919C36.8786 32.6028 36.9683 32.5976 37.0539 32.5986C37.269 32.6009 37.4842 32.6011 37.6994 32.599C37.7698 32.5981 37.8403 32.5971 37.9107 32.5957L37.9107 32.758C37.8403 32.7566 37.7698 32.7555 37.6994 32.7547C37.4842 32.7526 37.269 32.7529 37.0539 32.7551C36.9683 32.7561 36.8786 32.7509 36.7935 32.7617L36.7935 32.5919Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7419 32.6953C36.7497 32.6255 36.7456 32.5535 36.7476 32.4833C36.7545 32.3333 36.7985 32.2014 36.9678 32.1818C37.1372 32.1773 37.2389 32.2696 37.2703 32.4329C37.28 32.5095 37.277 32.5844 37.2688 32.661L37.1107 32.6435C37.1176 32.5831 37.1207 32.5236 37.1133 32.463C37.0985 32.3835 37.0693 32.3432 36.9847 32.3438C36.9081 32.35 36.9104 32.4229 36.9073 32.4872C36.9059 32.5558 36.9033 32.627 36.911 32.6953L36.7419 32.6953Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1946 32.625C37.2014 32.5644 37.1982 32.5015 37.1987 32.4407C37.1997 32.31 37.1895 32.1634 37.2753 32.0549C37.3731 31.9631 37.4935 31.9947 37.6095 32.0291C37.6881 32.0525 37.7652 32.0724 37.8475 32.0749C37.8636 32.075 37.8795 32.0749 37.8955 32.0745L37.8997 32.2382C37.8806 32.2387 37.8615 32.2389 37.8424 32.2387C37.746 32.2356 37.6556 32.2126 37.5637 32.1851C37.5216 32.1726 37.4436 32.1379 37.3995 32.161C37.3362 32.2163 37.3589 32.3677 37.3595 32.4407C37.36 32.5015 37.3568 32.5644 37.3636 32.625L37.1946 32.625Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7424 32.6451L36.7424 32.7617L36.8934 32.7617L36.8934 32.6451L36.7424 32.6451Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.338 30.8118C37.6853 30.8118 37.9672 31.0692 37.9672 31.3864C37.9672 31.7036 37.6853 31.9609 37.338 31.9609C36.9906 31.9609 36.7087 31.7036 36.7087 31.3864C36.7087 31.0692 36.9906 30.8118 37.338 30.8118ZM37.3219 30.995C37.5585 30.995 37.7505 31.1704 37.7505 31.3864C37.7505 31.6025 37.5585 31.7778 37.3219 31.7778C37.0853 31.7778 36.8933 31.6025 36.8933 31.3864C36.8933 31.1704 37.0853 30.995 37.3219 30.995Z",
    fill: "#4A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5083 41.7437L34.5083 41.2183C34.5083 40.9834 34.3164 40.793 34.0798 40.793L31.0086 40.793C30.7719 40.793 30.5801 40.9834 30.5801 41.2183L30.5801 41.7437C30.5801 41.9786 30.7719 42.169 31.0086 42.169L34.0798 42.169C34.3164 42.169 34.5083 41.9786 34.5083 41.7437Z",
    fill: "#60585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3545 26.3804L34.3545 25.855C34.3545 25.6201 34.1626 25.4297 33.926 25.4297L30.8548 25.4297C30.6181 25.4297 30.4263 25.6201 30.4263 25.855L30.4263 26.3804C30.4263 26.6153 30.6181 26.8057 30.8548 26.8057L33.926 26.8057C34.1626 26.8057 34.3545 26.6153 34.3545 26.3804Z",
    fill: "#60585A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.318466 33.8562C0.200565 28.2546 1.21297 27.396 1.37974 26.5682C3.3153 25.7406 19.6357 25.5835 20.9699 26.08C23.9919 26.4512 24.4923 25.8354 28.1344 25.6496C32.3879 25.2959 30.0227 26.1358 34.348 25.4297C38.8513 26.5026 38.943 24.4817 39.3711 33.7783C39.2512 42.3098 38.8512 41.1084 34.348 42.181C30.0227 41.4748 32.3879 42.3148 28.1344 41.9611C24.4925 41.7752 23.9921 41.1595 20.9699 41.5307C19.6358 42.0272 3.31549 41.8701 1.37974 41.0425C0.623355 39.7468 0.318466 36.3133 0.318466 33.8556L0.318466 33.8562Z",
    fill: "url(#paint0_linear_8440_135794)",
    stroke: "#E2E2E2",
    strokeOpacity: 0.45912,
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3317 27.0587L21.2165 28.1255C21.2165 28.1255 13.5005 28.1255 13.3722 27.9732C13.2436 27.8207 11.0574 26.6016 11.0574 26.6016C11.0574 26.6016 25.0745 26.9063 25.332 27.0588L25.3317 27.0587Z",
    fill: "url(#paint1_radial_8440_135794)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5812 40.7973L21.466 39.7305C21.466 39.7305 13.75 39.7305 13.6217 39.8828C13.4931 40.0353 11.307 41.2544 11.307 41.2544C11.307 41.2544 25.324 40.9497 25.5815 40.7972L25.5812 40.7973Z",
    fill: "url(#paint2_radial_8440_135794)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0552 26.8417C37.0457 26.2637 27.4435 26.3059 26.6864 27.2306C27.4895 28.1239 28.2356 33.2984 28.1662 34.2823C28.2469 35.2874 27.7306 39.2212 26.9388 40.4298C26.8236 40.7557 38.055 41.4071 38.8122 40.4823C39.6961 37.5921 39.6961 27.9975 38.0556 26.8417L38.0552 26.8417Z",
    fill: "url(#paint3_linear_8440_135794)",
    stroke: "#DBDBDB",
    strokeOpacity: 0.45912,
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5543 27.0679C26.5543 27.0679 27.8969 30.3143 27.9312 33.9362C27.9632 37.1976 27.4509 38.6706 26.6823 40.6545C24.2486 40.414 21.9431 40.1735 21.1746 39.5723C22.5837 34.0416 22.5837 33.6809 21.1746 28.1502C21.9428 28.0298 26.4263 26.9477 26.5541 27.0679L26.5543 27.0679Z",
    fill: "url(#paint4_radial_8440_135794)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4139 27.2548C26.4139 27.2548 27.65 30.4146 27.6816 33.9403C27.711 37.1148 27.2393 38.5485 26.5318 40.4797C24.2913 40.2457 22.1689 40.0116 21.4613 39.4264C22.7585 34.0428 22.7584 33.6921 21.4613 28.3084C22.1688 28.1914 26.296 27.1381 26.4139 27.2552L26.4139 27.2548Z",
    fill: "black",
    fillOpacity: 0.7044,
    stroke: "black",
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8749 28.7514C9.91151 28.1386 4.23142 27.6484 4.23142 27.6484C3.36707 28.6289 2.99664 33.6533 2.99664 33.7762C2.99664 34.1438 3.36708 39.1682 4.60185 40.0263C5.34271 40.0263 10.6522 39.536 12.9983 39.0458C12.3809 34.7566 12.6279 28.9969 12.8748 28.7517L12.8749 28.7514Z",
    fill: "url(#paint5_radial_8440_135794)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6174 29.0103C9.78743 28.4251 4.36327 27.957 4.36327 27.957C3.53786 28.8933 3.1841 33.6914 3.1841 33.8088C3.1841 34.1599 3.53786 38.9581 4.71703 39.7775C5.42455 39.7775 10.4948 39.3093 12.7356 38.8412C12.146 34.7451 12.3818 29.2447 12.6177 29.0103L12.6174 29.0103Z",
    fill: "black",
    fillOpacity: 0.78616,
    stroke: "black",
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4709 40.9492L25.353 42.3536C25.353 42.3536 24.6455 43.0558 24.2918 42.5877C23.938 42.1195 24.4097 40.9492 24.4097 40.9492L25.4709 40.9492Z",
    fill: "url(#paint6_linear_8440_135794)",
    stroke: "black",
    strokeOpacity: 0.55346,
    strokeWidth: 0.990285
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2349 26.8306L25.117 25.4262C25.117 25.4262 24.4094 24.724 24.0557 25.1922C23.7019 25.6603 24.1736 26.8306 24.1736 26.8306L25.2349 26.8306Z",
    fill: "url(#paint7_linear_8440_135794)",
    stroke: "black",
    strokeOpacity: 0.54717,
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6453 27.1363L20.8719 27.9555C20.8719 27.9555 13.7967 27.9555 13.6789 27.8384C13.561 27.7214 11.5564 26.7852 11.5564 26.7852C11.5564 26.7852 24.4094 27.0192 24.6455 27.1363L24.6453 27.1363Z",
    fill: "black",
    fillOpacity: 0.68554,
    stroke: "black",
    strokeWidth: 0.792228
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8809 40.7137L21.1075 39.8945C21.1075 39.8945 14.0323 39.8945 13.9145 40.0115C13.7966 40.1286 11.792 41.0648 11.792 41.0648C11.792 41.0648 24.645 40.8308 24.8811 40.7137L24.8809 40.7137Z",
    fill: "black",
    fillOpacity: 0.74843,
    stroke: "black",
    strokeWidth: 0.792228
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8123 12.9364C29.8123 19.5915 22.1265 24.0267 20.231 25.0193C19.9671 25.1575 19.6574 25.1575 19.3936 25.0193C17.498 24.0267 9.81226 19.5915 9.81226 12.9364C9.81226 7.11282 14.6576 3.23047 19.8123 3.23047C25.1456 3.23047 29.8123 7.11282 29.8123 12.9364Z",
    fill: "white",
    stroke: "#1F1F1F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8440_135794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 21C24.418 21 27.9998 17.4183 27.9998 13C27.9998 8.58172 24.418 5 19.9998 5C15.5815 5 11.9998 8.58172 11.9998 13C11.9998 17.4183 15.5815 21 19.9998 21Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0391 16.4414C20.0264 16.4414 20.0137 16.454 19.9883 16.454C19.9756 16.454 19.9629 16.4414 19.9375 16.4414H20.0391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4379 17.7279C24.9891 19.7058 22.6332 21.0035 19.9875 21.0035C17.3418 21.0035 14.9985 19.7184 13.5371 17.7279C14.671 16.5184 16.208 15.8759 17.493 15.5483C17.3796 16.468 17.8584 17.7027 17.871 17.6649C18.3497 16.5562 19.9749 16.4554 19.9749 16.4554C19.9749 16.4554 21.6001 16.5436 22.0914 17.6649C22.104 17.6901 22.5828 16.468 22.4694 15.5483C23.767 15.8759 25.304 16.5184 26.4379 17.7279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9779 14.7016C21.9779 14.8654 21.8771 15.7347 20.0378 16.4402H19.937C18.0976 15.7347 17.9968 14.8654 17.9968 14.7016C18.0094 14.3741 18.085 14.0465 18.2236 13.7441C18.7275 14.3111 19.3323 14.689 19.9874 14.689C20.6299 14.689 21.2472 14.3237 21.7512 13.7441C21.8897 14.0465 21.9779 14.3741 21.9779 14.7016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0832 16.7293L20.6801 17.5356H19.2943L18.8911 16.7293C19.4454 16.4899 19.9872 16.4521 19.9872 16.4521C19.9872 16.4521 20.5415 16.4899 21.0832 16.7293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8657 20.9242C19.2311 20.9746 19.609 20.9998 19.9996 20.9998C20.3775 20.9998 20.7555 20.9746 21.1334 20.9242L20.6925 17.5479H19.3067L18.8657 20.9242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9786 14.6733C21.9786 14.6733 22.0668 15.6812 19.988 16.4497C19.988 16.4497 21.6132 16.5379 22.1046 17.6592C22.1172 17.7096 23.0621 15.2655 21.9786 14.6733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9972 14.6733C16.9263 15.2655 17.8586 17.697 17.8838 17.6592C18.3625 16.5505 20.0003 16.4497 20.0003 16.4497C17.909 15.6812 17.9972 14.6733 17.9972 14.6733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8524 13.9961C21.3233 14.563 20.6934 14.9284 19.9879 14.9284C19.2823 14.9284 18.6524 14.563 18.1233 13.9961C18.1485 13.9079 18.1863 13.8197 18.2241 13.7441C18.728 14.3111 19.3327 14.689 19.9879 14.689C20.643 14.689 21.2477 14.3237 21.7516 13.7441C21.7894 13.8197 21.8272 13.9079 21.8524 13.9961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4263 12.0664C23.1617 12.5074 22.7586 12.772 22.4562 12.7216C21.8515 13.8428 20.9696 14.6743 19.9869 14.6743C19.0042 14.6743 18.1223 13.8302 17.5176 12.7216C17.2153 12.7594 16.8121 12.5074 16.5475 12.0664C16.2326 11.5499 16.22 10.983 16.5223 10.794C16.5979 10.7562 16.6735 10.731 16.7617 10.7436C16.9633 11.2601 17.2404 11.5751 17.2404 11.5751C16.9507 9.97511 18.1349 9.79873 17.9334 8.26172C17.9334 8.26172 18.6767 9.91211 20.8058 8.75306L20.642 9.06802C23.6153 8.4003 22.62 11.9027 22.5948 11.9909C22.9349 11.5625 23.1491 11.1342 23.2751 10.7436C23.3255 10.7436 23.3885 10.7688 23.4263 10.794C23.7538 10.9704 23.7412 11.5499 23.4263 12.0664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6998 6.6001C21.9392 6.57491 22.3298 6.78908 22.3298 6.78908C21.2589 5.56703 19.5077 6.34813 19.5077 6.34813C20.0998 5.8442 20.629 5.89459 20.629 5.89459C18.1219 5.51664 17.6935 7.01585 17.6935 7.01585C17.5801 6.83947 17.5801 6.5875 17.5927 6.46152C17.4164 6.76388 17.6053 7.36861 17.6053 7.36861C17.429 6.92766 16.8116 7.00325 16.8116 7.00325C17.3408 7.09144 17.429 7.419 17.429 7.419C16.1061 7.91034 16.3329 9.28357 16.3329 9.28357L16.6479 8.90561C16.2573 10.4048 17.2526 11.5639 17.2526 11.5639C16.9628 9.96388 18.1471 9.7875 17.9455 8.2505C17.9455 8.2505 18.6888 9.90089 20.8179 8.74183L20.6542 9.0568C23.6652 8.37648 22.6069 11.9922 22.6069 11.9922C23.6778 10.6316 23.514 9.23317 23.514 9.23317L23.64 9.73711C23.9801 7.46939 21.6998 6.6001 21.6998 6.6001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8440_135794",
    x1: 1.06085,
    y1: 40.143,
    x2: 1.21063,
    y2: 27.4122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.200833,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494515,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773265,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8440_135794",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.195 27.3636) rotate(90) scale(0.762022 7.1374)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34332F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8440_135794",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4445 40.4925) rotate(90) scale(0.762022 7.1374)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34332F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8440_135794",
    x1: 40.326,
    y1: 31.7094,
    x2: 26.0075,
    y2: 40.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0193957,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483083,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_8440_135794",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5537 33.8574) rotate(90) scale(6.79826 3.37907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34332F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_8440_135794",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.99767 33.8381) rotate(90) scale(6.18921 5.0009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34332F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8440_135794",
    x1: 24.5506,
    y1: 42.4784,
    x2: 24.8503,
    y2: 40.9712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8440_135794",
    x1: 24.8537,
    y1: 26.9588,
    x2: 24.5541,
    y2: 25.1504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8440_135794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7778,
    height: 39.402,
    fill: "white",
    transform: "translate(39.4021 25) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8440_135794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11.9998 5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCar);
export default __webpack_public_path__ + "static/media/user-car.9b07909e7eabfc7ab2912f3a241cf780.svg";
export { ForwardRef as ReactComponent };